import { all, call, put, takeLatest } from 'redux-saga/effects';

import { request } from '@app/services';
import * as endpoints from './endpoints';
import {
  addProject,
  addProjectFailed,
  addProjectSuccess,
  getProjects,
  getProjectsFailed,
  getProjectsSuccess,
  updateProjectStatus,
  updateProjectStatusFailed,
  updateProjectStatusSuccess,
  getProjectDetails,
  getProjectDetailsFailed,
  getProjectDetailsSuccess,
  updateProject,
  updateProjectFailed,
  updateProjectSuccess,
} from './slice';

function* getProjectSaga(action: ReturnType<typeof getProjects>): any {
  try {
    const q = action.payload;
    const result = yield call(request.get, endpoints.getProjects, {
      params: {
        q,
      },
    });
    yield put(getProjectsSuccess(result.data));
  } catch (err) {
    yield put(getProjectsFailed(err));
  }
}
//
function* addProjectSaga(action: ReturnType<typeof addProject>): any {
  try {
    const {
      client,
      description,
      estimatedEndDate,
      managers,
      members,
      priority,
      projectName,
      startDate,
      projectImage,
    } = action.payload;
    const formData = new FormData();
    formData.append('name', projectName);
    formData.append('client', client.toString());
    formData.append('description', description);
    formData.append('startDate', startDate);
    formData.append('endDate', estimatedEndDate);
    formData.append('priority', priority);
    formData.append('members', JSON.stringify(members));
    formData.append('managers', JSON.stringify(managers));
    formData.append('image', projectImage);

    const result = yield call(request.post, endpoints.addProject, formData);
    yield put(addProjectSuccess(result.data));
    yield put(getProjects());
  } catch (err) {
    yield put(addProjectFailed(err));
  }
}
//
function* updateProjectStatusSaga(action: ReturnType<typeof updateProjectStatus>): any {
  try {
    const { id, status } = action.payload;
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const result = yield call(request.put, `${endpoints.updateProjectStatus}${id}`, {
      status,
    });
    yield put(updateProjectStatusSuccess(result.data));
    yield put(getProjects());
  } catch (err) {
    yield put(updateProjectStatusFailed(err));
  }
}
//
function* getProjectDetailsSaga(action: ReturnType<typeof getProjectDetails>): any {
  try {
    const projectId = action.payload;
    // eslint-disable-next-line @typescript-eslint/no-base-to-string, @typescript-eslint/restrict-template-expressions
    const result = yield call(request.get, `${endpoints.getProjectDetails}${projectId}`);
    yield put(getProjectDetailsSuccess(result.data));
  } catch (err) {
    yield put(getProjectDetailsFailed(err));
  }
}
//
function* updateProjectSaga(action: ReturnType<typeof updateProject>): any {
  try {
    const {
      id,
      client,
      description,
      estimatedEndDate,
      managers,
      members,
      priority,
      projectName,
      startDate,
      projectImage,
    } = action.payload;
    const formData = new FormData();
    formData.append('name', projectName);
    formData.append('client', client.toString());
    formData.append('description', description);
    formData.append('startDate', startDate);
    formData.append('endDate', estimatedEndDate);
    formData.append('priority', priority);
    formData.append('members', JSON.stringify(members));
    formData.append('managers', JSON.stringify(managers));
    if (typeof projectImage === 'object') {
      formData.append('image', projectImage);
    }
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const result = yield call(request.put, `${endpoints.updateProject}${id}`, formData);
    yield put(updateProjectSuccess(result.data));
    yield put(getProjectDetails(id));
    yield put(getProjects());
  } catch (err) {
    yield put(updateProjectFailed(err));
  }
}

function* projectSagas() {
  yield all([
    takeLatest(addProject, addProjectSaga),
    takeLatest(
      [getProjects, addProjectSuccess, updateProjectSuccess, updateProjectStatusSuccess],
      getProjectSaga
    ),
    takeLatest(updateProjectStatus, updateProjectStatusSaga),
    takeLatest(getProjectDetails, getProjectDetailsSaga),
    takeLatest(updateProject, updateProjectSaga),
  ]);
}
export { projectSagas };
